import { GetterTree } from 'vuex';
import IWalmartCheckoutLocation from './models/Location';
import { IWalmartCheckoutState } from './state';
import {
    GET_CHECKOUT_URI, GET_LOCATION, GET_NUM_OF_PRODUCTS, GET_PRICE,
} from './types';

const getters: GetterTree<IWalmartCheckoutState, IWalmartCheckoutState> = {
    [GET_NUM_OF_PRODUCTS](state): number {
        return state.products.length;
    },
    [GET_PRICE](state): number {
        const total = state.products.map(p => p.Price).reduce((a, b) => a + b, 0.00);
        return Math.round((total + Number.EPSILON) * 100) / 100;
    },
    [GET_CHECKOUT_URI](state): string {
        if (!state.location || !state.location.FulfillmentStoreId || !state.location.FulfillmentStoreId.length) {
            return 'invalid location';
        }
        if (!state.gotoUri || !state.gotoUri.length) {
            return 'invalid goto url';
        }
        if (!state.affiliateUri || !state.affiliateUri.length) {
            return 'invalid affilate url';
        }
        const walmartUri = new URL(state.gotoUri);
        const items = (state.products.length)
            ? state.products
                .map(p => `${p.Id}_${p.Qty}`)
                .reduce((a, b) => `${a},${b}`)
                .trim()
            : '';
        const affilateUri = `${state.affiliateUri}?storeId=${state.location.FulfillmentStoreId}&items=${items}`;
        walmartUri.searchParams.append('u', affilateUri);
        return walmartUri.toString();
    },
    [GET_LOCATION](state): IWalmartCheckoutLocation {
        return state.location;
    },
};

export default getters;
